const initialState = {
    data: null,
};
export const EditDocumentPropReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'EDITDOCUMENTPROP_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'EDITDOCUMENTPROP_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default EditDocumentPropReducer;